/** @jsxImportSource @emotion/react */
import { css } from '@emotion/react';
import { darken } from 'polished';

export default $ => css`
  .p-no-margin p {
    margin: 0 !important;
    margin-bottom: 0 !important;
  }

  .footer-btn-grouped-tab-item {
    cursor: pointer;
    padding: 0.33rem 0.5rem;
    font-size: ${$.fontSizeSm};
    white-space: nowrap;
    text-decoration: none !important;
  }

  .uweentity-form.hidden {
    display: none;
  }

  form.rjsf,
  div.rjsf {
    margin-top: -1.25rem;

    .alert {
      input {
        background-color: transparent;
        color: inherit;
        border-color: transparent;

        &:focus {
          outline: none;
          box-shadow: none;
        }
      }
    }

    .form-group {
      .control-label {
        margin-bottom: 0.5rem;
      }

      .checkbox-inline > span,
      .checkbox > label > span,
      .rjsf-field-radio-group > .radio,
      .field-radio-group > .radio,
      .radio-inline {
        margin-right: 8px;

        > input[type='checkbox'],
        > span > input[type='radio'] {
          margin-right: 8px;
        }
      }

      .rjsf-field-radio-group.radio-group-buttons .btn + .btn,
      .field-radio-group.radio-group-buttons .btn + .btn {
        margin-left: 12px;
      }

      @media (min-width: 768px) {
        .input-wrapper,
        input,
        select,
        .dropdown {
          // max-width: 20rem;
        }
      }

      .btn.btn-block {
        margin-left: 3rem;
        margin-right: 3rem;
        width: 90%;
      }
    }

    .title-2-lines > label {
      height: 3em;
    }

    .array-field-vertical .array-item-list {
      flex-direction: column;
      max-width: 30rem;

      > .array-item {
        display: flex;

        td.array-item-field {
          .form-group:not(:has(.form-group)) {
            margin-top: 4px;
            margin-bottom: 4px;
          }
        }

        > .col-xs-9 {
          flex-grow: 1;

          .form-group {
            margin-bottom: 0;
          }
        }

        > .col-xs-3 {
          display: flex;
          align-items: center;
        }
      }
    }

    .array-cards > .array-item-list > .array-item.for-object-row {
      padding-left: 1em;
      padding-right: 1em;
    }

    tr.for-object-row > th {
      white-space: pre;
    }

    .array-item.for-object-row > td,
    tr.array-item.panel-row > td {
      padding: 0;

      > .form-group {
        margin-bottom: 0;

        > .control-label,
        .form-group > .control-label {
          display: none;
        }

        &.bordered > .form-group > .prop-fields,
        &.bordered > .rjsf-form-group > .prop-fields,
        &.bordered > .form-group > .collapse > .prop-fields,
        &.bordered > .rjsf-form-group > .collapse > .prop-fields,
        &.bordered > .form-group > .collapsing > .prop-fields,
        &.bordered > .rjsf-form-group > .collapsing > .prop-fields {
          padding-left: 12px;
          padding-right: 12px;
        }
      }
    }

    .array-item {
      td.array-item-field {
        .form-group {
          padding: 0 !important;
        }

        .form-group:not(:has(.form-group)) {
          margin-top: 4px;
          margin-bottom: 4px;
        }
      }

      td.array-item-toolbox {
        padding-left: 0;
        padding-right: 0;

        .btn-group .btn i.fa {
          transition: transform 100ms ease-in-out;
        }

        .btn-group .btn:hover {
          i.fa {
            transform: scale(1.1);
          }
        }
      }
    }

    .form-group:has(.form-group) {
      margin-bottom: 0;
    }

    .form-group.bordered {
      border: 1px solid ${$.gray100};
    }

    legend[id^='root_'][id$='__title'] {
      position: relative;
      cursor: default;
      border-radius: ${$.borderRadius} ${$.borderRadius} 0 0;
      box-sizing: content-box;

      @media (max-width: 768px) {
        margin-left: -5px;
        margin-right: 9px;
        padding-left: 14px;
        padding-right: 0;
      }

      &:last-of-type {
        margin-bottom: 0;
      }

      &.type-subsection,
      &.type-subsubsection {
        background-color: ${$.secondaryMain};
        color: inherit;
        width: auto;
        padding-left: 1.25rem;
        padding-right: 1.25rem;
        margin-left: 0rem;
        margin-right: 0rem;
        font-size: 1.25rem;
        font-weight: normal;

        &.bottom-section {
          border-radius: 0 0 12px 12px;
          margin-bottom: 12px;
        }

        &.type-subsubsection {
          font-size: 1rem;
        }

        > .expandable {
          top: -2px;
          right: 5px;
          color: inherit;

          > * {
            font-size: 1.75rem;
          }

          &.type-subsubsection > * {
            font-size: 1.5rem;
          }
        }
      }

      &.type-label {
        color: inherit;
        background-color: transparent;
      }

      > .expandable {
        position: absolute;
        right: 12px;
        height: 1.5em;
        width: 1.5em;
        background-color: transparent;
        border-width: 0;
        color: ${$.white};

        > * {
          font-size: 2.5rem;
        }
      }
    }

    legend.type-label:not(.control-label) {
      font-size: large;
    }

    .btn.btn-add {
      color: ${$.secondaryMain};
    }

    .radio-column > .rjsf-field-radio-group,
    .radio-column > .field-radio-group {
      flex-direction: column;
    }

    legend#root__title:empty {
      margin: 0;
    }
  }

  .rjsf-field-boolean,
  .field-boolean {
    position: relative;

    .form-check .checkbox,
    .checkbox {
      display: inline-flex;
      align-items: center;
    }

    .help-block {
      display: inline;
      margin-bottom: 0;
      vertical-align: middle;
    }
  }

  .help-block {
    display: inline;
    margin-bottom: 0;
    margin-left: 3px;
    vertical-align: middle;
  }

  .rjsf-field.field-object.flex-row > fieldset {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;

    > * {
      margin-left: 12px;
    }
  }

  .no-title > .animate-height > .auto-content > fieldset > legend,
  .no-title > fieldset > legend,
  .no-title > label {
    display: none;
  }

  .row-index {
    width: 4em;

    > .form-group > input {
      text-align: center;
    }
  }

  .form-component > .card {
    border: 0 !important;
  }

  .form-container {
    display: flex;
    flex-direction: row;
    justify-content: center;
    position: relative;
    min-height: 0;

    .uweentity-form.form-component > .form-sticky-header > .uweentity-title {
      border-radius: 0px !important;
    }

    .sidepanel-left {
      .expandable-tab-side-panel-tab {
        &:hover,
        &:focus {
          font-weight: 500;
          position: relative;
          padding-bottom: 1.35rem;
          right: 2px;
          background-color: ${darken(0.05, $.primaryMain)};
          outline: 1px solid ${$.primaryMain};
          outline-offset: 1px;

          &:before {
            content: '';
            display: block;
            position: absolute;
            width: calc(100% + 2px);
            height: 3px;
            right: -1px;
            bottom: -3px;
            background-color: ${$.primaryMain};
          }
        }
      }
    }

    .sidepanel-right {
      .expandable-tab-side-panel-tab {
        &:hover,
        &:focus {
          font-weight: 500;
          position: relative;
          padding-bottom: 1.35rem;
          left: 2px;
          background-color: ${darken(0.05, $.primaryMain)};

          &:before {
            content: '';
            display: block;
            position: absolute;
            width: calc(100% + 2px);
            height: 3px;
            left: -1px;
            bottom: -3px;
            background-color: ${$.primaryMain};
          }
        }
      }
    }

    .sidepanel-bottom {
      .expandable-tab-side-panel-tab {
        &:hover,
        &:focus {
          font-weight: 500;
          position: relative;
          padding-bottom: 1.35rem;
          bottom: 2px;
          background-color: ${darken(0.05, $.dangerMain)};

          &:before {
            content: '';
            display: block;
            position: absolute;
            width: calc(100% + 2px);
            height: 3px;
            right: -1px;
            bottom: -3px;
            background-color: ${darken(0.05, $.dangerMain)};
          }
        }
      }
    }

    > .sidepanel {
      display: flex;
      flex-direction: column;
      --tab-width: 120px;
      --tab-height: 24px;
      --tab-gap: 10px;
      --tab-v-offset: calc(36px + 2 * 8px);
      --tab-border-radius: ${$.borderRadius};
      --collapsed-width: calc(var(--tab-height) + var(--tab-gap));
      --expanded-width: 260px;

      &.expanded {
        flex: 0 0 var(--expanded-width);
      }

      flex: 0 0 var(--collapsed-width);
      width: var(--collapsed-width);

      > .expandable-tab-side-panel-tab {
        width: var(--tab-width);
        height: var(--tab-height);
        border-radius: var(--tab-border-radius) var(--tab-border-radius) 0px 0px;
        font-size: 0.85rem;
        margin-bottom: var(--tab-width);
        border-width: 0;
        color: ${$.white};
        background-color: ${$.primaryMain};
      }

      > .expandable-tab-side-panel-panel {
        margin-left: calc(var(--tab-gap) / 2);
        margin-right: calc(var(--tab-gap) / 2);
        border-radius: ${$.borderRadius};

        > .card-header {
          position: relative;
          background-color: ${$.primaryMain};
          color: ${$.white};
          font-size: 1.65rem;
          padding-top: 0;
          font-weight: bold;
          padding-bottom: 0;

          > .btn-bar {
            position: absolute;
            right: 0;
            top: -8px;
            padding: 0;

            > .btn {
              position: relative;
              right: auto;
              top: auto;
              border-radius: 50%;
              border: 0;
              background-color: ${$.primaryMain};
              color: ${$.white};
              width: 24px;
              min-width: auto;
              max-width: auto;
              padding: 0;
              height: 24px;
              margin-left: 12px;

              &:hover {
                color: ${$.primaryMain};
                background-color: ${$.white};
              }
              .fa {
                font-size: 16px;
                display: flex;
                align-items: center;
                justify-content: center;
              }
            }
          }
        }

        > .card-body {
          overflow: auto;
          max-height: 40vh;
          border-radius: 0;
        }

        &::after {
          content: ' ';
          height: 15px;
        }
      }

      > .expandable-tab-side-panel-tab + .expandable-tab-side-panel-panel {
        margin-top: var(--tab-v-offset);
      }

      > .expandable-tab-side-panel-panel + .expandable-tab-side-panel-panel {
        margin-top: calc(2 * var(--tab-gap));
      }

      &.sidepanel-left {
        position: sticky;
        top: ${$.navbarHeight};
        align-self: flex-start;

        > .expandable-tab-side-panel-tab {
          transform: rotate(-90deg) translate(calc(-1 * (var(--tab-width) + var(--tab-v-offset))), var(--tab-gap));
          transform-origin: top left;
        }

        &.expanded > .expandable-tab-side-panel-tab {
          transform: rotate(-90deg) translate(calc(-1 * (var(--tab-width) + var(--tab-v-offset))), calc(var(--expanded-width) - var(--tab-height)));
        }

        order: 1;
      }

      &.sidepanel-right {
        position: sticky;
        top: ${$.navbarHeight};
        align-self: flex-start;

        > .expandable-tab-side-panel-tab {
          transform: rotate(90deg) translate(calc(var(--tab-width) + var(--tab-v-offset)), calc(var(--tab-width) - var(--tab-height)));
          transform-origin: top right;
        }

        &.expanded > .expandable-tab-side-panel-tab {
          transform: rotate(90deg) translate(calc(var(--tab-width) + var(--tab-v-offset) - var(--tab-height)), var(--tab-width));
          transform-origin: bottom right;
        }

        order: 3;
      }

      &.sidepanel-bottom {
        position: fixed;
        bottom: 0;
        left: 50%;
        transform: translateX(-50%);
        width: auto;
        height: auto;
        z-index: 999;
        flex-direction: column-reverse;
        align-items: center;

        > .expandable-tab-side-panel-tab {
          position: relative;
          background-color: ${$.dangerMain};
          color: ${$.white};
          border: 1px solid ${$.dangerMain};
          width: 140px;
          height: 40px;
          display: flex;
          align-items: center;
          justify-content: center;
          margin-bottom: 0;

          &:hover {
            background-color: ${darken(0.05, $.dangerMain)};
            padding-bottom: 0px;
            border-color: ${$.dangerMain};
          }
        }

        > .expandable-tab-side-panel-panel {
          position: absolute;
          left: 50%;
          transform: translateX(-50%);
          width: 600px;
          max-width: calc(100vw - 40px);
          max-height: 600px;
          background: #ffffff;
          border: 1px solid ${$.dangerMain};
          border-radius: 10px 10px 0 0;
          box-shadow: 0 -4px 12px rgba(0, 0, 0, 0.15);
          display: flex;
          flex-direction: column;
          z-index: 100;
          margin-left: 0;
          margin-right: 0;

          > .card-header {
            background: ${$.dangerMain};
            color: white;
            border-bottom: 1px solid ${$.dangerMain};
            padding: 8px 12px;
            display: flex;
            align-items: center;
            justify-content: space-between;
            flex-shrink: 0;
            font-size: 14px;
            font-weight: 600;

            > .btn-bar {
              position: static;
              right: auto;
              top: auto;
              display: flex;
              gap: 4px;

              > .btn {
                background: transparent;
                border: 1px solid rgba(255, 255, 255, 0.3);
                color: white;
                padding: 4px 8px;
                font-size: 12px;
                width: auto;
                height: auto;
                min-width: auto;
                max-width: auto;
                margin-left: 0;
                border-radius: 4px;

                &:hover {
                  background: rgba(255, 255, 255, 0.1);
                  color: white;
                }

                .fa {
                  font-size: 12px;
                }
              }
            }
          }

          > .card-body {
            flex: 1;
            overflow-y: auto;
            padding: 0;
            max-height: 250px;
          }
        }

        &.expanded {
          flex: none;
          width: auto;
        }

        order: 4;
      }
    }

    > .form-component {
      order: 2;
      width: 100%;
    }

    > .toolbar-bottom-affix {
      position: fixed;
      bottom: 0;
      margin-left: 5px;
    }
  }

  .rjsf-field.field-inline {
    display: flex;
    flex-direction: row;

    > label {
      margin-bottom: 0;
      padding-right: 12px;

      &:after {
        content: ': ';
      }
    }

    > .form-group {
      margin-bottom: 0;
      flex-grow: 1;

      > input {
        width: 100%;
        max-width: 1200px;
      }
    }
  }

  .has-buttons-position-top {
    position: relative;

    .buttons-position-top {
      top: 3px;
      position: absolute;
      right: 40px;
    }
  }

  .has-buttons-position-top-outside {
    position: relative;
    display: flex;
    // margin-left: 5em;
    // justify-content: space-between;
    gap: 8px;

    .buttons-position-top-outside {
      position: absolute;
      top: 4px;
      right: 4px;

      .array-item-remove {
        padding-right: 10px !important;
        padding-left: 10px !important;
      }
    }

    .buttons-position-top {
      flex-grow: 0;
      flex-shrink: 0;
    }
  }

  $cell-widths: (
    l: 16rem,
    m: 10rem,
    sm: 4.5rem,
  );

  th,
  td {
    &.w-l {
      width: 16rem;
      max-width: 16rem;
    }
    &.w-m {
      width: 10rem;
      max-width: 10rem;
    }
    &.w-sm {
      width: 4.5rem;
      max-width: 4.5rem;
    }
  }

  .for-object-row {
    > th {
      text-align: center;
      vertical-align: middle;
    }

    .w-sm-s {
      width: 4.5rem;
      font-size: 13px;
      padding: 2px;
    }

    ::-webkit-input-placeholder,
    .w-sm-s :-ms-input-placeholder,
    .w-sm-s ::placeholder {
      color: #b4b4b4;
      font-size: 14px;
    }
  }

  .quill {
    height: 300px;
  }

  .schema-field {
    min-width: 0;

    &.align-start > .form-check {
      justify-content: flex-start;
    }

    .row {
      margin-bottom: 8px;
    }

    .schema-field-delete-btn {
      margin-bottom: -4px;
      padding: 0;
    }

    fieldset {
      display: grid;
      gap: 8px;
      min-width: 0;
      max-width: 100%;
    }
  }

  .property-table {
    width: 100%;

    td .array-item-remove {
      .fa-times {
        transition: transform 100ms ease-in-out;
      }

      &:hover {
        .fa-times {
          transform: scale(1.1);
        }
      }
    }
  }

  .align-end {
    align-items: flex-end;
  }

  .justify-start {
    justify-content: flex-start;
  }

  .align-start {
    align-items: flex-start;
  }

  .text-input-tooltip {
    color: white;
    background-color: black;
  }

  .danger-highlighted {
    position: relative;
    border: 2px solid ${$.dangerMain} !important;
    box-shadow: 0 0 0 4px ${$.dangerMain}40 !important;
  }

  .primary-highlighted {
    position: relative;
    border: 2px solid ${$.primaryMain} !important;
    box-shadow: 0 0 0 4px ${$.primaryMain}40 !important;
  }

  .warning-highlighted {
    position: relative;
    border: 2px solid ${$.warningMain} !important;
    box-shadow: 0 0 0 4px ${$.warningMain}40 !important;
  }

  .small-label {
    font-size: 0.75rem;
    color: ${$.gray600};
    display: block;
    margin-bottom: 2px;
  }

  .dataremark-modal-dialog {
    margin: 8px auto !important;
  }

  .remarks-filter-row {
    display: flex;
    flex-wrap: wrap;
    gap: 6px;
    margin-bottom: 10px;

    .remarks-filter-chip {
      display: inline-flex;
      align-items: center;
      padding: 3px 10px;
      border: 1.5px solid;
      font-size: 11px;
      border-radius: 4px;
      font-weight: 600;
      cursor: pointer;
      transition: background 0.15s, color 0.15s, border-color 0.15s;
      line-height: 1.4;

      &.remarks-filter-chip--pill {
        border-radius: 999px;
      }
    }
  }

  .uweentity-dataremarks-partial {
    padding: 12px 16px;
    height: 100%;
    display: flex;
    flex-direction: column;

    .dataremarks-grid-partial {
      display: flex;
      flex-direction: column;
      gap: 8px;
      flex: 1;
      overflow-y: auto;
    }

    .dataremark-item-card {
      position: relative;
      border: 1px solid #dee2e6;
      border-radius: 0.375rem;
      box-shadow: 0 1px 2px rgba(0, 0, 0, 0.08);
      transition: all 0.2s ease;
      background: white;
      cursor: pointer;
      font-size: 0.875rem;

      &:before {
        position: absolute;
        content: '';
        height: calc(100% + 2px);
        width: 5px;
        left: -1px;
        top: -1px;
        background-color: ${$.dangerMain};
        border-top-left-radius: 0.3rem;
        border-bottom-left-radius: 0.3rem;
      }

      &.resolved:before {
        background-color: ${$.successMain};
      }

      &.responded:before {
        background-color: ${$.warningMain};
      }

      &:hover {
        box-shadow: 0 2px 6px rgba(0, 0, 0, 0.12);
        border-color: ${$.primaryMain};
      }

      &.resolved,
      &.responded {
        opacity: 0.85;
      }

      h6 {
        font-size: 0.8rem;
        color: #212529;
      }
    }
  }

  .striped-bgs {
    &:nth-of-type(even) {
      background-color: ${$.gray100};
    }

    &:nth-of-type(odd) {
      background-color: ${$.white};
    }
  }

  .show-buttons-on-hover {
    .btn-group,
    .btn-danger {
      visibility: hidden !important;
    }

    &:hover {
      .btn-group,
      .btn-danger {
        visibility: visible !important;
      }
    }

    > div:first-of-type {
      width: 100%;
    }
  }

  .prop-fields {
    display: grid;
    gap: 8px;
    padding-top: 8px;
    padding-bottom: 8px;
  }

  .separator-border {
    // padding-top: 20px;
    // padding-bottom: 8px;
    &:nth-of-type(n + 2) {
      border-top: 1px solid ${$.gray400};
    }
  }

  .dont-animate-height {
    .animate-height {
      overflow: visible !important;
    }
  }

  #scrolling-container {
    display: flex;
    flex-direction: column;
    min-height: 0;

    .ql-toolbar {
      height: 42px;
    }

    .ql-container {
      height: calc(100% - 42px);
      overflow-y: auto;
    }
  }

  .ghost-input {
    background-color: transparent !important;
    border-color: transparent !important;
    border-bottom: 1.5px solid rgba(0, 0, 0, 0.25) !important;
    border-top: none !important;
    border-left: none !important;
    border-right: none !important;
    border-radius: 0 !important;
    box-shadow: none !important;
    padding-left: 0 !important;
    color: inherit;
    transition: border-color 0.2s ease;
  }

  .ghost-input:focus {
    background-color: transparent !important;
    border-bottom-color: rgba(0, 0, 0, 0.7) !important;
    box-shadow: none !important;
    outline: none;
  }

  .ghost-input:hover:not(:focus) {
    border-bottom-color: rgba(0, 0, 0, 0.45) !important;
  }

  .ghost-input::placeholder {
    color: rgba(0, 0, 0, 0.35);
  }

  /* ─── InputGroup integration ─── */

  /* When ghost-input is inside an InputGroup, flatten the whole group */
  .input-group:has(.ghost-input) {
    border-bottom: 1.5px solid rgba(0, 0, 0, 0.25);
    transition: border-color 0.2s ease;
  }

  .input-group:has(.ghost-input:focus) {
    border-bottom-color: rgba(0, 0, 0, 0.7);
  }

  .input-group:has(.ghost-input:hover:not(:focus)) {
    border-bottom-color: rgba(0, 0, 0, 0.45);
  }

  /* Remove the individual bottom border from the input when in a group
   (the group container owns it) */
  .input-group .ghost-input {
    border-bottom: none !important;
  }

  /* InputGroupText addon — ghost style */
  .input-group:has(.ghost-input) .input-group-text,
  .input-group:has(.ghost-input) .input-group-append .input-group-text {
    background-color: transparent !important;
    border: none !important;
    border-radius: 0 !important;
    box-shadow: none !important;
    padding-left: 6px;
    padding-right: 0;
    color: inherit;
  }

  /* Fallback for browsers that don't support :has()
   Add the class 'input-group-ghost' to the InputGroup wrapper */
  .input-group-ghost {
    border-bottom: 1.5px solid rgba(0, 0, 0, 0.25);
    transition: border-color 0.2s ease;
  }

  .input-group-ghost:focus-within {
    border-bottom-color: rgba(0, 0, 0, 0.7);
  }

  .input-group-ghost:hover:not(:focus-within) {
    border-bottom-color: rgba(0, 0, 0, 0.45);
  }

  .input-group-ghost .ghost-input {
    border-bottom: none !important;
  }

  .input-group-ghost .input-group-text,
  .input-group-ghost .input-group-append .input-group-text {
    background-color: transparent !important;
    border: none !important;
    border-radius: 0 !important;
    box-shadow: none !important;
    padding-left: 6px;
    padding-right: 0;
  }

  /* Filter/search input group — no border at all until focused, hovered, or holding a value */
  .input-group-ghost.array-filter-input-group {
    border-bottom-color: transparent;
    margin-bottom: 0 !important;
  }

  .input-group-ghost.array-filter-input-group:focus-within,
  .input-group-ghost.array-filter-input-group:hover,
  .input-group-ghost.array-filter-input-group.has-value {
    border-bottom-color: rgba(0, 0, 0, 0.7);
  }

  /* =============================================
   Ghost Checkbox — Reactstrap v8 compatible
   
   IMPORTANT: <input> elements don't support ::before/::after
   in any browser, so we can't draw a checkmark that way.
   Instead, hide the real input and use a sibling <span>
   as the visual box + checkmark.
 
   Required markup pattern:
   
     <label className="ghost-checkbox-wrap">
       <Input type="checkbox" className="ghost-checkbox-input" />
       <span className="ghost-checkbox-box" />
       Optional label text
     </label>
 
   With reactstrap FormGroup:
 
     <FormGroup check className="ghost-checkbox-wrap">
       <Input type="checkbox" className="ghost-checkbox-input" id="cb" />
       <Label check for="cb" className="ghost-checkbox-box" />
     </FormGroup>
 
   ============================================= */

  /* Hide the real input but keep it accessible */
  .ghost-checkbox-input {
    position: absolute !important;
    opacity: 0 !important;
    width: 0 !important;
    height: 0 !important;
    margin: 0 !important;
    pointer-events: none;
  }

  /* The visual checkbox box */
  .ghost-checkbox-box {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
    width: 16px;
    height: 16px;
    min-width: 16px;
    border: 1.5px solid rgba(255, 255, 255, 0.35);
    border-radius: 3px;
    background-color: transparent;
    transition: border-color 0.2s ease;
    cursor: pointer;
    position: relative;
  }

  /* Checkmark drawn via ::after on the span — this works */
  .ghost-checkbox-box::after {
    content: '';
    display: block;
    width: 4px;
    height: 8px;
    border: 1.5px solid transparent;
    border-top: none;
    border-left: none;
    transform: rotate(45deg) translate(-1px, -1px);
    transition: border-color 0.15s ease;
  }

  /* Checked: show the checkmark */
  .ghost-checkbox-input:checked ~ .ghost-checkbox-box,
  .ghost-checkbox-input:checked + .ghost-checkbox-box {
    border-color: rgba(255, 255, 255, 0.75);
  }

  .ghost-checkbox-input:checked ~ .ghost-checkbox-box::after,
  .ghost-checkbox-input:checked + .ghost-checkbox-box::after {
    border-color: rgba(255, 255, 255, 0.75);
    border-top: none;
    border-left: none;
  }

  /* Focus ring on the visual box */
  .ghost-checkbox-input:focus ~ .ghost-checkbox-box,
  .ghost-checkbox-input:focus + .ghost-checkbox-box {
    outline: 2px solid rgba(255, 255, 255, 0.2);
    outline-offset: 2px;
  }

  /* Disabled */
  .ghost-checkbox-input:disabled ~ .ghost-checkbox-box,
  .ghost-checkbox-input:disabled + .ghost-checkbox-box {
    opacity: 0.35;
    cursor: not-allowed;
  }

  /* ─── Wrapper label ─── */

  .ghost-checkbox-wrap {
    display: inline-flex;
    align-items: center;
    gap: 8px;
    cursor: pointer;
    padding-left: 0 !important;
    margin-bottom: 0;
    user-select: none;
    font-weight: normal;
  }

  .ghost-checkbox-wrap:hover .ghost-checkbox-box {
    border-color: rgba(255, 255, 255, 0.55);
  }

  .ghost-checkbox-wrap:hover .ghost-checkbox-input:checked ~ .ghost-checkbox-box,
  .ghost-checkbox-wrap:hover .ghost-checkbox-input:checked + .ghost-checkbox-box {
    border-color: rgba(255, 255, 255, 0.9);
  }

  /* Disabled wrapper */
  .ghost-checkbox-wrap:has(.ghost-checkbox-input:disabled) {
    cursor: not-allowed;
  }

  /* ─── Reactstrap FormGroup check layout fix ─── */

  /* When used as a FormGroup check, override reactstrap's default indentation */
  .form-check.ghost-checkbox-wrap {
    padding-left: 0;
  }

  .form-check.ghost-checkbox-wrap .form-check-label {
    padding-left: 0;
    margin: 0;
  }

  /* ── Resizable sidebar workspace ── */

  .sp-workspace {
    flex: 1;
    min-width: 0;
    display: flex;
    flex-direction: row;
    order: 2;

    /* Right-split mode: cap height so the panel and form each scroll independently */
    &.sp-right-active {
      height: calc(100vh - ${$.navbarHeight} - var(--form-footer-height, 0px));

      > .sp-form-wrap > .uweentity-form.form-component {
        flex: 1;
        min-height: 0;
        overflow-y: auto;

        > .form-sticky-header {
          top: 0;
        }

        /* In this scroll context top is relative to the form, not the page */
        .sp-side-tabs-inner,
        .form-tabs.sticky-tab-nav,
        .form-grouped-tabs.sticky-tab-nav {
          top: var(--form-sticky-header-height, 0px);
        }
      }
    }
  }

  .sp-form-wrap {
    flex: 1;
    min-width: 0;
    display: flex;
    flex-direction: column;

    /* Bottom-split mode: cap height so both areas are visible without scrolling */
    &.sp-bottom-active {
      height: calc(100vh - ${$.navbarHeight} - var(--form-footer-height, 0px));

      > .uweentity-form.form-component {
        flex: 1;
        min-height: 0;
        overflow-y: auto;

        /* Sticky header sticks to top of its own scroll container */
        > .form-sticky-header {
          top: 0;
        }

        /* In this scroll context top is relative to the form, not the page */
        .sp-side-tabs-inner,
        .form-tabs.sticky-tab-nav,
        .form-grouped-tabs.sticky-tab-nav {
          top: var(--form-sticky-header-height, 0px);
        }
      }
    }
  }

  .sp-form-body {
    display: flex;
    flex-direction: row;

    > .form-component-fields {
      flex: 1;
      min-width: 0;
    }
  }

  .sp-v-resizer {
    width: 5px;
    background: ${$.cardBorderColor};
    cursor: col-resize;
    flex-shrink: 0;
    transition: background 0.15s;

    &:hover,
    &.sp-resizer-active {
      background: ${$.primaryMain};
    }
  }

  .sp-side-panel {
    display: flex;
    flex-direction: column;
    background: ${$.white};
    border-left: ${$.cardBorderWidth} solid ${$.cardBorderColor};
    overflow: hidden;
    flex-shrink: 0;
  }

  .sp-h-resizer {
    height: 5px;
    background: ${$.cardBorderColor};
    cursor: row-resize;
    flex-shrink: 0;
    transition: background 0.15s;

    &:hover,
    &.sp-resizer-active {
      background: ${$.primaryMain};
    }
  }

  .sp-bottom-panel {
    display: flex;
    flex-direction: column;
    background: ${$.white};
    border-top: ${$.cardBorderWidth} solid ${$.cardBorderColor};
    overflow: hidden;
    flex-shrink: 0;
  }

  .sp-side-tabs {
    display: flex;
    flex-direction: column;
    background: ${$.gray100};
    border-left: ${$.cardBorderWidth} solid ${$.cardBorderColor};
    flex-shrink: 0;
  }

  .sp-side-tabs-inner {
    position: sticky;
    top: calc(${$.navbarHeight} + var(--form-sticky-header-height, 0px));
    display: flex;
    flex-direction: column;
  }

  .sp-side-tab {
    writing-mode: vertical-rl;
    text-orientation: mixed;
    padding: 14px 7px;
    cursor: pointer;
    font-size: 11px;
    font-weight: 600;
    letter-spacing: 1px;
    text-transform: uppercase;
    border: none;
    border-radius: 0 !important;
    border-bottom: 1px solid ${$.cardBorderColor};
    user-select: none;
    transition: background 0.15s, color 0.15s;

    &.tab-primary {
      color: ${$.gray600};
      background: ${$.gray100};

      &:hover {
        background: ${darken(0.04, $.gray100)};
        color: ${$.primaryMain};
      }

      &.active-primary {
        background: ${$.primaryMain};
        color: ${$.white};
        outline: 0.5px solid ${$.white};
        outline-offset: -3px;
      }
    }

    &.tab-danger {
      background: ${$.dangerMain}40;
      color: rgb(33, 33, 33);

      &:hover {
        background: ${darken(0.05, $.dangerMain)};
        color: ${$.white};
      }

      &.active-danger {
        outline: 0.5px solid ${$.white};
        color: ${$.white} !important;
        background: ${darken(0.05, $.dangerMain)};
        outline-offset: -3px;
      }
    }

    &.tab-warning {
      background: ${$.warningMain}40;
      color: ${$.gray800};

      &:hover,
      &:active {
        background: ${darken(0.05, $.warningMain)};
      }

      &.active-warning {
        color: white;
        background: ${darken(0.05, $.warningMain)};
        outline: 0.5px solid ${$.white};
        outline-offset: -3px;
      }
    }
  }

  .sp-panel-hdr {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 8px 12px;
    flex-shrink: 0;
    color: ${$.white};

    &.color-primary {
      background: ${$.primaryMain};
    }

    &.color-danger {
      background: ${$.dangerMain};
    }

    &.color-warning {
      background: ${$.warningMain};
      color: ${$.gray800};
    }
  }

  .sp-panel-hdr-title {
    font-weight: 600;
    font-size: 13px;
    letter-spacing: 0.3px;
    color: white;
  }

  .sp-panel-hdr-actions {
    display: flex;
    gap: 4px;
    align-items: center;
    margin-left: 8px;
    flex-shrink: 0;
  }

  .sp-icon-btn {
    background: rgba(255, 255, 255, 0.18);
    border: none;
    color: ${$.white};
    width: 26px;
    height: 26px;
    border-radius: 4px;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
    transition: background 0.15s;
    padding: 0;

    &:hover {
      background: rgba(255, 255, 255, 0.35);
    }

    &.sp-icon-btn-active {
      background: rgba(255, 255, 255, 0.4);
      outline: 1.5px solid rgba(255, 255, 255, 0.8);
    }
  }

  .sp-panel-content {
    flex: 1;
    overflow: auto;
    display: flex;
    flex-direction: column;
  }

  .sp-float-modal {
    position: fixed;
    background: ${$.white};
    border: 1px solid ${$.cardBorderColor};
    border-radius: 7px;
    box-shadow: 0 8px 32px rgba(0, 0, 0, 0.18);
    z-index: 1300;
    display: flex;
    flex-direction: column;
    overflow: hidden;
    min-width: 240px;
    min-height: 160px;
  }

  .sp-resize-grip {
    position: absolute;
    bottom: 0;
    right: 0;
    width: 16px;
    height: 16px;
    cursor: nwse-resize;

    &::after {
      content: '';
      display: block;
      width: 8px;
      height: 8px;
      border-right: 2px solid ${$.gray400};
      border-bottom: 2px solid ${$.gray400};
      position: absolute;
      bottom: 4px;
      right: 4px;
    }
  }

  .react-datepicker-wrapper {
    flex: 1;
    cursor: pointer;
    width: 100%;
    max-height: 39px;
  }

  .react-datepicker-popper {
    z-index: 9999 !important;
  }

  .react-datepicker__calendar-icon {
    height: 18px;
    width: 16px;
    left: 0;
  }

  .react-datepicker__header {
    background-color: ${$.primaryMain} !important;
    text-transform: capitalize;

    h2 {
      color: ${$.white} !important;
      font-weight: 500 !important;
    }
  }

  .react-datepicker__day-name > span {
    display: block;
    text-transform: capitalize;
    font-weight: 400;
  }

  .react-datepicker__month-container {
    font-family: ${$.fontFamily};
  }

  .react-datepicker__day--selected {
    background-color: ${$.primaryMain} !important;
    font-weight: 500;
  }

  .react-datepicker__input-container {
    overflow-x: hidden;
    > i {
      z-index: 8 !important;
      right: 0;
      padding: 0.7rem;
    }

    > input {
      cursor: pointer;
      padding: 8px 12px 8px 30px !important;

      &.date-picker-no-icon {
        padding: 8px 12px 8px 12px !important;
      }
    }

    > svg {
      top: 2px;
    }
  }

  .react-datepicker__year-read-view {
    background: transparent;
    color: ${$.white};
    display: flex;
    align-items: center;

    .react-datepicker__year-read-view--down-arrow {
      transform: scale(0.5) rotate(135deg);
      right: -6px;
      top: 3px;
    }
  }

  .react-datepicker__year-option--selected_year {
    font-weight: 500;
  }

  .react-datepicker__day--outside-month {
    opacity: 0.65;
  }

  .react-datepicker__year-option:has(.react-datepicker__navigation--years-upcoming),
  .react-datepicker__year-option:has(.react-datepicker__navigation--years-previous) {
    position: relative;

    &:after {
      content: '…' !important;
      display: block;
      position: absolute;
      font-size: 30px;
      top: 0;
      right: 0;
      height: 100%;
      width: 100%;
    }
  }

  textarea {
    field-sizing: content;
  }

  .bg-transparent {
    background: transparent !important;
  }

  .computed-field-calculated-by-us {
    color: red;
  }

  .computed-field-conflict {
    button:has(.computed-field-calculated-by-us),
    button:has(.computed-field-reported-by-you) {
      .computed-field-calculated-by-us,
      .computed-field-reported-by-you {
        color: ${$.gray400};
      }

      &:hover {
        .computed-field-calculated-by-us,
        .computed-field-reported-by-you {
          color: ${$.gray300};
        }
      }
    }

    button:disabled {
      opacity: 1;
    }
  }

  .rjsf-field-string.text-center > div.static-markdown-blurb-container,
  .rjsf-field-string > div.static-markdown-blurb-container.text-center,
  .rjsf-field.text-center > label.control-label,
  label.control-label.text-center {
    justify-content: center;
  }
`;
